export enum AuthenticationProvider {
  Cognito = 'Cognito',
  Email = 'Email',
  OIDC = 'OIDC',
}
